var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCentricity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.01 142.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ca5ad;}.cls-2{fill:#505050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71,8.9A62.12,62.12,0,1,0,133.11,71,62.12,62.12,0,0,0,71,8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,57.64l0,26.73a13.37,13.37,0,1,1,0-26.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.38,71A13.36,13.36,0,0,1,71,84.37l0-26.73A13.39,13.39,0,0,1,84.38,71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,45.14V29A42,42,0,1,0,71,113V96.89a25.88,25.88,0,1,1,0-51.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113,71a42.06,42.06,0,0,1-42,42V96.89a25.88,25.88,0,0,0,0-51.75V29A42.06,42.06,0,0,1,113,71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,16.15V0a71,71,0,0,0,.1,142V125.89A54.87,54.87,0,1,1,71,16.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142,71A71.09,71.09,0,0,1,71.06,142V125.89A54.87,54.87,0,0,0,71,16.15V0A71.08,71.08,0,0,1,142,71Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentricity);
export default __webpack_public_path__ + "static/media/centricity.efaf965ed78eddc8cb0405e670bda198.svg";
export { ForwardRef as ReactComponent };